import { useState, useEffect,useMemo } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import eyeIcon from "../../utils/images/eye.svg"
import NavBar from "../../marginals/navBar";
import "../../utils/css/ClaimDetails.css";
import "../../utils/css/infromationRequired.css";
import ClaimTimeline from "./claimTimeline";
import { ScreenName, ACCESSIBILITY_LABELS, OPDConfig } from "../../../config/constants";
import MobileSecurityFooter from '../../customFiles/MobileSecurityFooter';
import { getFormName } from "../../utils/constants/constants";
import { EARLY_CLAIM_STATUSES } from "../../../utils/constants";
import { isMobile } from "../../utils/miscutils";
import { formatDate } from "../../utils/miscutils";
import { isWebView } from "../../utils/deviceUtils";
import { useTaskDeviceBridge } from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import { getClaimDisplayStatus,ADVANCED_BILL_STATUSES } from "../../utils/miscutils";
import { getMbServerToken } from "../../../utils/cookieUtils";
import axiosInstance from "../../../utils/axiosInterceptor";
import { handleKeyboardClick } from "../../../utils/keyboardUtils";

function capitalizeFirstLetter(str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

const spellOutId = (id) => String(id).split("").join(" ");

export default function ClaimDetails(props) {
  const page = "Reimbursement Claim Details";
  const navigate = useNavigate();
  const taskDeviceBridge = useTaskDeviceBridge();
  const claimBlacklist = [
    "115303627",
    "308461501",
    "337354543",
    "843562839",
    "738778762",
    "655763269",
    "075132625",
    "072476070",
    "022284812",
    "812081003",
    "117030364",
    "533516374",
    "013774264",
    "636258127",
    "698102829",
    "524882061",
    "250281196",
    "566233691",
    "042930589",
    "828811344",
    "626418480",
    "917416078",
    "318170290",
    "055352466",
    "546223140",
    "122927756",
    "837008119",
    "812464593",
    "377997159",
    "802912384",
    "605971035",
    "487051845",
    "226731098",
    "646522345",
    "217895851",
    "119950522",
    "307403017",
    "133285320",
    "040014168",
    "424824174",
    "300620080",
    "620810234",
    "979404848",
    "915748016",
    "998809715",
    "649062425",
    "014186274",
    "092319498",
    "331595226",
    "643455201",
    "949623985",
    "619567753",
    "870695518",
    "664085978",
    "464639753",
    "122501870",
    "639845327",
    "393313396",
    "181813780",
    "563923536",
    "294028129",
    "873768417",
    "543195202",
    "673244138",
    "943161379",
    "037122948",
    "946414188",
    "393393058",
    "613502346",
    "997218120",
    "420438435",
    "667623435",
    "596019004",
    "030125782",
    "111849604",
    "999069371",
    "418047692",
    "344460053",
    "696861498",
    "173509894",
    "797022866",
    "430499717",
    "420151837",
    "539566139",
    "240018434",
    "553861335",
    "351838962",
    "393287652",
    "538452075",
    "256394174",
    "784397632",
    "301056642",
    "143380659",
    "200904940",
    "190376657",
    "641186883",
    "282570062",
    "933947789",
    "979590553",
    "272418046",
    "917207630",
    "842927550",
    "693394678",
    "314737631",
    "940765279",
    "719997811",
    "564984379",
    "271201386",
    "297916630",
    "014363649",
    "370966414",
    "634168396",
    "378013963",
    "662694717",
    "259463910",
    "854834401",
    "868892663",
    "705144896",
    "803136686",
    "951783143",
    "345770065",
    "635288418",
    "063330285",
    "518843961",
    "648396457",
    "181073973",
    "443022570",
    "044769809",
    "179366820",
    "889325063",
    "762765875",
    "016138586",
    "226762724",
    "102192901",
    "981812702",
    "998507541",
    "622174599",
    "203404890",
    "597067467",
    "781715162",
    "391819629",
    "748893065",
    "551480093",
    "488727980",
    "974421472",
    "014559523",
    "420504204",
    "429842201",
    "388672118",
    "277484349",
    "257618243",
    "208391952",
    "603424537",
    "608417528",
    "412838442",
    "820741104",
    "804545765",
    "965933051",
    "079574293",
    "663533519",
    "881842344",
    "494822701",
    "500427693",
    "032020939",
    "290268035",
    "673947480",
    "068717224",
    "991498844",
    "887902348",
    "907718445",
    "874134634",
    "883071999",
    "190019032",
    "042314756",
    "809642326",
    "279766021",
    "629518238",
    "982225374",
    "261450933",
    "807535195",
    "231714072",
    "835048652",
    "488903567",
    "331997499",
    "105312642",
    "936053336",
    "438800315",
    "028602526",
    "012161012",
    "440710673",
    "188883834",
    "531506127",
    "683531411",
    "403961507",
    "874375377",
    "699232081",
    "708339467",
    "605462321",
    "126409531",
    "407739683",
    "606863183",
    "874145949",
    "824614454",
    "506958467",
    "571786750",
    "113022312",
    "538822518",
    "197628444",
    "781651074",
    "672464993",
    "250907715",
    "466502075",
    "303380673",
    "779629493",
    "112570727",
    "851810539",
    "545901720",
    "067585036",
    "865241934",
    "804738751",
    "281578613",
    "439076053",
    "286531707",
    "585113874",
    "483848365",
    "227354800",
    "144904654",
    "455002602",
    "832947764",
    "783665890",
    "355055708",
    "792334607",
    "637848001",
    "336858044",
    "457431710",
    "254861966",
    "614293100",
    "874047101",
    "042976592",
    "782462081",
    "273778502",
    "688181342",
    "410849995",
    "818985003",
    "870552797",
    "466071096",
    "454124616",
    "557418844",
    "422231956",
    "591006847",
    "862776215",
    "742855565",
    "442021209",
    "076986791",
    "129266501",
    "781709665",
    "207461434",
    "411219780",
    "482669306",
    "871411950",
    "718962420",
    "369897218",
    "184102685",
    "983832208",
    "575751027",
    "868006606",
    "171710383",
    "143885664",
    "692607225",
    "755565508",
    "410192845",
    "925394609",
    "205540401",
    "906137397",
    "982633240",
    "809565489",
    "877670894",
    "880402385",
    "728271619",
    "593196806",
    "856695071",
    "697814247",
    "290937321",
    "619769160",
    "668327231",
    "377379864",
    "423980521",
    "703146074",
    "755436976",
    "476403500",
    "439871296",
    "705673201",
    "592165252",
    "932603194",
    "805747600",
    "327651163",
    "985530574",
    "220039141",
    "037482892",
    "538206860",
    "262602996",
    "017135306",
    "058507860",
    "027600654",
    "953650050",
    "389477417",
    "401958968",
    "276382312",
    "949222952",
    "457922798",
    "069724704",
    "837868642",
    "764991673",
    "001793685",
    "095683726",
    "121610513",
    "644837698",
    "164849132",
    "752746613",
    "659872747",
    "124413329",
    "586257955",
    "340799074",
    "165670185",
    "053556886",
    "742404829",
    "365105824",
    "633266514",
    "028558558",
    "378087594",
    "207210255",
    "988730070",
    "474591312",
    "370436797",
    "133916088",
    "335705286",
    "719278711",
    "701048433",
    "908131802",
    "729331632",
    "655989416",
    "891050203",
    "190440654",
    "759023897",
    "143760617",
    "278852885",
    "225650186",
    "524314479",
    "689879408",
    "665519128",
    "720457135",
    "654176444",
    "252865095",
    "166894952",
    "993086695",
    "670622897",
    "157921692",
    "267392641",
    "830098413",
    "638980923",
    "139947814",
    "018892784",
    "473487401",
    "226718701",
    "709160670",
    "489664166",
    "058225150",
    "123225303",
    "237140326",
    "102500427",
    "410020691",
    "694057109",
    "717148735",
    "349254627",
    "343914397",
    "213907969",
    "405692315",
    "801337227",
    "077235372",
    "063727240",
    "159429139",
    "227887696",
    "833601940",
    "665439404",
    "202433862",
    "792438798",
    "192337922",
    "159701088",
    "273666712",
    "041617505",
    "691194819",
    "174782913",
    "923999614",
    "831518984",
    "352352039",
    "705567881",
    "208904227",
    "591052565",
    "129633933",
    "114835476",
    "978973515",
    "138721229",
    "184788399",
    "271317647",
    "390062351",
    "987301524",
    "489377837",
    "055331309",
    "797421132",
    "731183176",
    "133451480",
    "428433234",
    "455266007",
    "065089919",
    "129812825",
    "486914998",
    "203736066",
    "065309760",
    "564546891",
    "557609135",
    "126794789",
    "015977541",
    "233583322",
    "941415145",
    "863280168",
    "731975940",
    "308925473",
    "351447249",
    "557903518",
    "357028632",
    "275212508",
    "247166074",
    "015791145",
    "172800751",
    "867764782",
    "384490012",
    "966218474",
    "191936106",
    "004535901",
    "777659432",
    "513202359",
    "293907550",
    "868599983",
    "998035990",
    "259645863",
    "037228350",
    "325413337",
    "466979158",
    "462623088",
    "398004179",
    "878075378",
    "983841919",
    "263360202",
    "313978475",
    "319705828",
    "826431202",
    "996778024",
    "013101492",
    "309261603",
    "406573121",
    "703340315",
    "228924606",
    "737791777",
    "828402684",
    "450555096",
    "743062809",
    "871382566",
    "063786661",
    "008241116",
    "581758653",
    "669680070",
    "250662054",
    "764478266",
    "197481404",
    "287951409",
    "953898774",
    "033572911",
    "237830242",
    "632784698",
    "996534112",
    "100461938",
    "077723607",
    "181914644",
    "056832045",
    "580564200",
    "848294269",
    "324820810",
    "364943288",
    "336817528",
    "283875854",
    "569617815",
    "394389849",
    "495852242",
    "029037837",
    "792722084",
    "209314982",
    "742312340",
    "190058502",
    "241184982",
    "048888170",
    "605662709",
    "138130787",
    "289172042",
    "340102401",
    "902902796",
    "795111925",
    "157026032",
    "773350132",
    "105281491",
    "455282911",
    "418835457",
    "288591659",
    "652954749",
    "622449543",
    "275623806",
    "375056393",
    "164275125",
    "201563622",
    "891772849",
    "373134281",
    "693903289",
    "062075586",
    "513621204",
    "335960609",
    "570519045",
    "058269082",
    "474682544",
    "824296786",
    "024201746",
    "977052314",
    "155000269",
    "536508769",
    "835542310",
    "758023095",
    "410034222",
    "323362872",
    "232297925",
    "088604975",
    "407718307",
    "060808713",
    "233980353",
    "256526207",
    "158129410",
    "596793233",
    "504038325",
    "936536124",
    "099272959",
    "682938371",
    "427687225",
    "768316070",
    "843848735",
    "534754153",
    "330266733",
    "971967937",
    "516115041",
    "461114072",
    "562703207",
    "557710800",
    "577642277",
    "266063343",
    "760124269",
    "227417486",
    "301163695",
    "387168304",
    "136379533",
    "991371055",
    "748186522",
    "042085081",
    "112926898",
    "605981880",
    "345291880",
    "148567449",
    "744676992",
    "700374351",
    "087168902",
    "613715237",
    "903005113",
    "684984761",
    "049256219",
    "779804267",
    "292082696",
    "872330206",
    "278224588",
    "247515425",
    "261253701",
    "105779591",
    "772078969",
    "061670225",
    "328359429",
    "950881429",
    "432753508",
    "749668286",
    "230528999",
    "231535657",
    "337234254",
    "701747149",
    "113175792",
    "066122346",
    "214985046",
    "588145706",
    "097539470",
    "810447641",
    "816243885",
    "935410123",
    "845074876",
    "560091301",
    "930940262",
    "000232213",
    "353381569",
    "973533206",
    "991467250",
    "169595839",
    "142123060",
    "489954247",
    "157796440",
    "413110172",
    "691478629",
    "487194590",
    "991341178",
    "936941767",
    "621671363",
    "732726509",
    "455314738",
    "262382744",
    "353094512",
    "036665303",
    "469543162",
    "371405164",
    "319559912",
    "701970545",
    "583243029",
    "737090340",
    "406086645",
    "986722427",
    "122341429",
    "888616472",
    "036963396",
    "211497902",
    "312749288",
    "814189120",
    "005253357",
    "396552245",
    "512000056",
    "323338781",
    "540018827",
    "169930118",
    "984777428",
    "282896822",
    "656976814",
    "601078954",
    "341017735",
    "361020657",
    "480827049",
    "460161963",
    "966297609",
    "988595158",
    "935374165",
    "827050357",
    "850250819",
    "495930725",
    "157375583",
    "682772588",
    "035831600",
    "138548962",
    "574255165",
    "947129777",
    "516601096",
    "404431017",
    "384610605",
    "170429688",
    "122317776",
    "922303925",
    "930695696",
    "764179329",
    "034655476",
    "575446521",
    "433694405",
    "540468443",
    "842859044",
    "760729019",
    "246852215",
    "412493800",
    "945028277",
    "752407520",
    "354779545",
    "579175765",
    "949462594",
    "219098074",
    "559397733",
    "131198612",
    "747126723",
    "010124913",
    "479754142",
    "126116685",
    "642524605",
    "636783330",
    "581823244",
    "949286809",
    "338231728",
    "991462001",
    "380999582",
    "803043249",
    "676407109",
    "953117477",
    "339628125",
    "164409908",
    "725112433",
    "744704796",
    "108035857",
    "892523184",
    "971374245",
    "390820385",
    "863181590",
    "461416932",
    "319198214",
    "802012464",
    "119733225",
    "014424349",
    "769473385",
    "164109867",
    "276398202",
    "191653484",
    "314131691",
    "594323458",
    "925242591",
    "167403218",
    "078186452",
    "051248643",
    "900709758",
    "518807194",
    "959207354",
    "358889872",
    "721053894",
    "026071358",
    "046627245",
    "525831245",
    "556618789",
    "305128639",
    "955565143",
    "120269256",
    "619262593",
    "132235914",
    "217775901",
    "169792003",
    "766489025",
    "284754454",
    "345621633",
    "662159084",
    "125198022",
    "373098472",
    "257028243",
    "492909750",
    "249945929",
    "365391513",
    "043238806",
    "695390740",
    "490747679",
    "694155454",
    "662709886",
    "898010471",
    "216532999",
    "830014888",
    "981942198",
    "154543067",
    "077134438",
    "138378850",
    "770544913",
    "706828112",
    "553059867",
    "318872437",
    "833309758",
    "196405872",
    "771911838",
    "530162688",
    "573580945",
    "376501353",
    "684377536",
    "272887185",
    "070999461",
    "387477895",
    "210911678",
    "722318098",
    "932189535",
    "599647995",
    "632443843",
    "079360230",
    "904637260",
    "581838255",
    "433057944",
    "687241707",
    "739356951",
    "568729755",
    "819230351",
    "319777135",
    "611232776",
    "459352288",
    "461218466",
    "107328169",
    "148456101",
    "615670882",
    "705617486",
    "218127159",
    "980306110",
    "906006984",
    "477229601",
    "186941681",
    "170383086",
    "086784931",
    "008578533",
    "840162885",
    "656008886",
    "146855295",
    "737266882",
    "220928810",
    "404137616",
    "002698644",
    "968230326",
    "863719311",
    "349824680",
    "201974011",
    "691496503",
    "256915209",
    "300044828",
    "804496984",
    "523001369",
    "417662885",
    "387047207",
    "874214375",
    "580693659",
    "503328102",
    "304603220",
    "860068641",
    "652359274",
    "885603800",
    "489592706",
    "671430411",
    "825084618",
    "700610883",
    "018646503",
    "147907307",
    "563023454",
    "352115596",
    "746574890",
    "465250073",
    "466200562",
    "529530417",
    "029459356",
    "345220406",
    "797755746",
    "581426547",
    "464459898",
    "537813437",
    "218035499",
    "425056591",
    "848212973",
    "893705413",
    "182021453",
    "289482096",
    "476007044",
    "027441009",
    "426669052",
    "327382089",
    "816064222",
    "671446299",
    "750475149",
    "242684252",
    "629214516",
    "965043437",
    "290160817",
    "421612988",
    "862986924",
    "277018865",
    "224962905",
    "158928725",
    "017384961",
    "258241396",
    "567201023",
    "976541497",
    "762281552",
    "055530990",
    "212852099",
    "529800092",
    "866332359",
    "053228476",
    "067013533",
    "842831487",
    "420188513",
    "832195920",
    "925938069",
    "140415594",
    "485736007",
    "816942077",
    "799430733",
    "170821767",
    "694839211",
    "732132543",
    "451062023",
    "557022754",
    "431982508",
    "702208378",
    "151079165",
    "962758736",
    "809407879",
    "978547635",
    "905954469",
    "810515763",
    "200870007",
    "940102581",
    "558931409",
    "328717227",
    "301990978",
    "255110560",
    "163201746",
    "382589848",
    "943304519",
    "220494569",
    "499808342",
    "770512069",
    "123518402",
    "110839071",
    "485313240",
    "526705050",
    "593806140",
    "666196345",
    "640484488",
    "801572393",
    "055170297",
    "523162854",
    "936444615",
    "615765428",
    "063134949",
    "327359234",
    "040593657",
    "578552989",
    "603101023",
    "566396764",
    "153809011",
    "288310971",
    "592848414",
    "784724804",
    "542793555",
    "058663883",
    "668823297",
    "293760724",
    "186350410",
    "190006011",
    "111368550",
    "302855769",
    "318873737",
    "703584606",
    "840946271",
    "726191521",
    "554163845",
    "180796495",
    "146472074",
    "696503096",
    "623551805",
    "423985529",
    "602813468",
    "656963501",
    "251391633",
    "980817895",
    "881392707",
    "003190158",
    "130260346",
    "254985303",
    "401655921",
    "870763686",
    "215734763",
    "520025242",
    "276361927",
    "171821456",
    "477813830",
    "184819764",
    "205049592",
    "408116022",
    "268352871",
    "195196003",
    "089865475",
    "479752364",
    "762977464",
    "602005994",
    "348953409",
    "862149262",
    "406500070",
    "776041812",
    "335912893",
    "542647938",
    "537103209",
    "265463415",
    "315399674",
    "259388820",
    "060685836",
    "738244707",
    "140214224",
    "550248655",
    "659599189",
    "269104949",
    "402865671",
    "999600254",
    "881114502",
    "760429872",
    "643576418",
    "858240651",
    "349698794",
    "216552093",
    "050891473",
    "613733151",
    "818262118",
    "499658732",
    "449624682",
    "674371870",
    "385647327",
    "323363838",
    "239823111",
    "306913263",
    "480581049",
    "064871775",
    "941188145",
    "432762461",
    "903690027",
    "704101938",
    "664954658",
    "521959410",
    "660335428",
    "227525288",
    "584418494",
    "464797623",
    "777181985",
    "982623885",
    "089937194",
    "652037820",
    "797139409",
    "587927767",
    "687795355",
    "649100383",
    "817791085",
    "746820480",
    "028992233",
    "378519816",
    "446073398",
    "059263353",
    "822916300",
    "318436912",
    "899893220",
    "803347340",
    "666949493",
    "716674092",
    "212379384",
    "508252570",
    "962225937",
    "849647138",
    "502233290",
    "355734175",
    "609526374",
    "022592955",
    "948844895",
    "726913368",
    "357946006",
    "470777994",
    "658039408",
    "921974357",
    "271297729",
    "999657217",
    "130075670",
    "400651033",
    "660212210",
    "612755281",
    "141446178",
    "360128690",
    "256102358",
    "138614272",
    "876873385",
    "821490718",
    "245524300",
    "409841179",
    "665054128",
    "676382084",
    "469134537",
    "227505848",
    "124351977",
    "805632614",
    "696460292",
    "233263374",
    "258131665",
    "732498005",
    "652374038",
    "417372365",
    "621917449",
    "648520943",
    "033384040",
    "994939110",
    "865107184",
    "702464638",
    "153512092",
    "959830281",
    "904443368",
    "103242994",
    "353086528",
    "019777840",
    "234937591",
    "016208010",
    "723938974",
    "126440753",
    "985255918",
    "377539107",
    "474487723",
    "742902056",
    "795206005",
    "070370899",
    "971832509",
    "715100053",
    "354381947",
    "811381575",
    "057416675",
    "680436985",
    "712670034",
    "631954039",
    "608683185",
    "176803096",
    "593956627",
    "202756793",
    "794336318",
    "109996793",
    "824835125",
    "393492257",
    "305237174",
    "774280533",
    "039035503",
    "998213713",
    "415134774",
    "606148149",
    "002167767",
    "435394083",
    "968176152",
    "664138604",
    "272725896",
    "802606840",
    "709381023",
    "463284977",
    "930980863",
    "530591960",
    "889557412",
    "555983883",
    "011561577",
    "646231420",
    "351768951",
    "049467822",
    "640072004",
    "697162824",
    "498803556",
    "946682030",
    "138919170",
    "301098583",
    "511469603",
    "954192857",
    "985060647",
    "520847592",
    "394326815",
    "068167581",
    "493947855",
    "029838915",
    "913182636",
    "556831064",
    "808768427",
    "220345828",
    "703385481",
    "497163756",
    "626044210",
    "413454003",
    "321820443",
    "697211808",
    "450766156",
    "802593318",
    "664225202",
    "683524797",
    "910704622",
    "662861212",
    "130957491",
    "415228263",
    "187653488",
    "713775669",
    "829285678",
    "554506551",
    "276848865",
    "576001180",
    "787691553",
    "897201019",
    "920014206",
    "992145914",
    "884393912",
    "314324640",
    "017772713",
    "171962828",
    "511757472",
    "114250130",
    "665150892",
    "199112087",
    "313388585",
    "507643191",
    "445603551",
    "032084346",
    "933119774",
    "041094685",
    "482305505",
    "018409713",
    "667262371",
    "119438719",
    "640245977",
    "966630736",
    "849050660",
    "146720895",
    "364455932",
    "932538488",
    "061457584",
    "487069325",
    "947257558",
    "394269301",
    "193079657",
    "969004484",
    "289228445",
    "349875838",
    "124984685",
    "642413548",
    "863214800",
    "643424448",
    "054313221",
    "503691725",
    "632295154",
    "843114526",
    "666457060",
    "534381050",
    "932647847",
    "194261215",
    "716384135",
    "402026865",
    "746092324",
    "739330272",
    "261834013",
    "558057495",
    "718440055",
    "649672936",
    "483457801",
    "955393740",
    "938074590",
    "073140623",
    "720781433",
    "808848091",
    "434672945",
    "100952439",
    "511862417",
    "525265962",
    "444614453",
    "570504263",
    "457296129",
    "689548065",
    "117358798",
    "288187317",
    "977691247",
    "357449483",
    "125944964",
    "333592929",
    "992342111",
    "533669284",
    "636501826",
    "912966600",
    "521427928",
    "865156039",
    "917983184",
    "883616239",
    "990829347",
  ];
  // const bankBlackList = [
  //     "00941140034050",
  //     "17581610025518",
  //     "03541610049888",
  //     "35234116895",
  //     "05451610512392",
  //     "919010067955123",
  //     "000101570554",
  //     "50100016776494",
  //     "156510100067118",
  //     "00471610010500",
  //     "50100065475686",
  //     "756201500502",
  //     "2121212",
  //     "50100076132155",
  //     "059801538241",
  //     "912010029411642",
  //     "922010010397310",
  //     "17491610000229",
  //     "754801000010",
  //     "50100388654921",
  //     "232323",
  //     "00761000018135",
  //     "50100330981435",
  //     "913010038392502",
  //     "918010081818957",
  //     "059801552883",
  //     "098501541731",
  //     "01331610031249",
  //     "50100018422902",
  //     "025401509178",
  //     "004701505946",
  //     "917010036366989",
  //     "914010040648296",
  //     "914010011837395",
  //     "918010041674201",
  //     "50100439207334",
  //     "921010013234116",
  //     "912010024932364",
  //     "5451140003132",
  //     "20122302584",
  //     "3711202329",
  //     "50100197988092",
  //     "916010020210237",
  //     "26321140000182",
  //     "912010053966819",
  //     "720201503646",
  //     "317501500307",
  //     "50100381132970",
  //     "50100017171003",
  //     "055801558579",
  //     "755201500893",
  //     "36019422121",
  //     "051901519069",
  //     "00211050047541",
  //     "913010006423056",
  //     "3955000101468804",
  //     "67540100004073",
  //     "0312169792",
  //     "50100059751951",
  //     "50100258187564",
  //     "05451140176994",
  //     "50100270596628",
  //     "041101520606",
  //     "04461610006653",
  //     "31992839194",
  //     "00771140011056",
  //     "05451610030603",
  //     "50100195558985",
  //     "914010031526703",
  //     "914010022491054",
  //     "919500759136",
  //     "05451140260335",
  //     "920010004818654",
  //     "055801612359",
  //     "231701521580",
  //     "024401519837",
  //     "50100258242403",
  //     "50100231842733",
  //     "19391610007899",
  //     "50100028790958",
  //     "916010078390059",
  //     "055010509104",
  //     "922010038873845",
  //     "624001534195",
  //     "50100094834158",
  //     "006901538460",
  //     "00041610093915",
  //     "016901552182",
  //     "921010044586808",
  //     "914010010258986",
  //     "50100264354563",
  //     "50100046742535",
  //     "000801538772",
  //     "922010023178074",
  //     "50100060359530",
  //     "915010019621038",
  //     "50100380459568",
  //     "18651130002156",
  //     "015201586202",
  //     "05451610430877",
  //     "6812538137",
  //     "111901508066",
  //     "072250764006",
  //     "50100443429404",
  //     "50100347958622",
  //     "917010050062351",
  //     "004001578991",
  //     "5461745817",
  //     "05451610409771",
  //     "50100069019133",
  //     "50100207423788",
  //     "05741140034518",
  //     "50100357428920",
  //     "50100563611303",
  //     "00771050020967",
  //     "1234",
  //     "004801538947",
  //     "918010020020164",
  //     "50100362174394",
  //     "003901238968",
  //     "004001530880",
  //     "080501505982",
  //     "50100008470521",
  //     "333010100015020",
  //     "091801505804",
  //     "915010046935005",
  //     "039901526218",
  //     "05451050071182",
  //     "50100145781948",
  //     "50100205038151",
  //     "917010083531006",
  //     "50100252568820",
  //     "50100158660730",
  //     "50100184812288",
  //     "50100524024262",
  //     "916010009694548",
  //     "081291676006",
  //     "06511140066763",
  //     "53110980292",
  //     "4413168869",
  //     "05451610489135",
  //     "004001556086",
  //     "403901501842",
  //     "20191610015270",
  //     "64194590920",
  //     "086601514299",
  //     "00531050099790",
  //     "50100172384310",
  //     "000201556003",
  //     "004001603691",
  //     "914010041232812",
  //     "05451610473558",
  //     "05451130016073",
  //     "53110838623",
  //     "603801563581",
  //     "50100362463511",
  //     "2413158064",
  //     "00521140094274",
  //     "50100093717566",
  //     "059801553200",
  //     "174901504236",
  //     "50100229101960",
  //     "920010034503557",
  //     "055801637743",
  //     "05451610448140",
  //     "055201514315",
  //     "20133555088",
  //     "50100010249881",
  //     "50100498501192",
  //     "910010025545976",
  //     "50100212242418",
  //     "002001618605",
  //     "000801609433",
  //     "2811916082",
  //     "25031140000577"
  // ]

  let apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
  let loginFlag = false;
  const { claimId } = useParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState();
  const [claimReportData, setClaimReportData] = useState();
  const [bankFlag, setBankFlag] = useState();
  let access_token = getMbServerToken()?.trim() || false;

  let relationShip = {
    1: "Self",
    2: "Mother",
    3: "Brother",
    4: "Daughter",
    5: "Father",
    7: "Sister",
    8: "Son",
    11: "Father-in-law",
    12: "Mother-in-law",
    17: "Spouse",
    23: "others",
  };
  const CLAIM_STATUS_COLORS = {
  'pre approved': '#004FB6',
  'pre rejected': '#004FB6',
  'partially pre approved': '#004FB6',
  'recheck': '#004FB6',
  'submitted': '#5E40AD',
  'information required': '#AB5200',
  'resubmitted': '#5E40AD',
  'approved': '#0F7A48',
  'partially approved': '#0F7A48',
  'payment settled': '#0F7A48',
  'rejected': '#AE0006',
  'raised for payment': '#004FB6'
};

const DEFAULT_STATUS_COLOR = '#252D38';

  const statusMismatch = useMemo(() => {
    if (
      !claimReportData ||
      !claimReportData[0]?.claimdata?.[0] ||
      !claimReportData[2]?.billdatat
    ) {
      return false;
    }
    const claimRemarks = claimReportData?.[0]?.claimdata?.[0]?.remarks ?? "No Remarks";
    const isClaimInEarlyStage = EARLY_CLAIM_STATUSES.includes(claimRemarks?.toLowerCase());
    
    const hasAdvancedBillStatus = claimReportData[2].billdatat.some(bill => {
      return ADVANCED_BILL_STATUSES.includes(bill?.status?.toLowerCase());
    });
    
    return isClaimInEarlyStage && hasAdvancedBillStatus;
  }, [claimReportData]);

  const claimDisplayStatus = useMemo(() => {
    if (!claimReportData?.[0]?.claimdata?.[0]?.remarks) return '';
    
    return getClaimDisplayStatus(
      claimReportData[0].claimdata[0].remarks,
      statusMismatch
    );
  }, [claimReportData, statusMismatch]);

  async function fetchUserDetails(longToken) {
    try {
      let data = {
        isSSOLogin: true,
        authServerAccessToken: longToken,
      };
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_WAPI_URL + "/MarketPlaceLogon"}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      let MarketPlaceLogonResp = response.data;

      if (!MarketPlaceLogonResp.isSuccess) {
        loginFlag = true;
        setLoading(false);
        setMessage("Unable to Fetch Claim Details.");
      } else {
        await claimMetaData(
          MarketPlaceLogonResp?.user?.corpDetails?.iwpEmployeeId,
        );
      }
    } catch (e) {
      loginFlag = true;
      setLoading(false);
      setMessage("Unable to Fetch Claim Information.");
    }
  }
  let selectedPolicy = JSON.parse(localStorage.getItem("selectedPolicy")) || {};

  const authHeader = {
    headers: {
      authtoken: access_token,
      entitypolicyid:
        selectedPolicy?.entityPolicyId ?? OPDConfig.Old_Policy_EntityPolicyId,
      subscriptionid:
        selectedPolicy?.primarySubscriptionId ??
        OPDConfig.Old_Policy_SubscriptionId,
    },
  };

  const claimMetaData = async (empId) => {
    const config = {
      headers: {
        authtoken: access_token,
      },
    };
    const claimMetaDataBody = {
      claimid: claimId,
      employeeid: empId,
    };

    try {
      const claimReport = await axiosInstance.post(
        `${apiUrl}/admin/claimmetaData`,
        claimMetaDataBody,
        config,
      );

      if (claimReport.status === 201) {
        if (claimReport.data.isSuccess === true) {
          const benefsBankDetails = await axiosInstance.get(
            `${apiUrl}/auth/getUserBankDetails`,
            authHeader,
          );

          setBankFlag(benefsBankDetails.data.result.bankflag);

          setClaimReportData(claimReport.data.result);
          setLoading(false);
        } else if (
          claimReport.data.isSuccess === false &&
          claimReport.data.message === "no claim matching"
        ) {
          setLoading(false);
          setMessage(
            "Sorry you are not authorized to view this claim " + claimId,
          );
        } else {
          setLoading(false);
          setMessage("Unable to Fetch Claim Details");
        }
      }
    } catch (error) {
      setLoading(false);
      if (error.response.data.message === "Token_Expired")
        setMessage("Session expired please login again");
      else setMessage("Unable to fetch your claims");
    }
  };

  useEffect(() => {
    fetchUserDetails(access_token);
  }, []);


const getBillStatusDisplay = (bill, claimRemarks, allBills, statusMismatch) => {
  const totalBills = allBills.length;
  const isSingleBill = totalBills === 1;
  const isMultipleBills = totalBills > 1;

  const isCurrentBillInfoRequired = bill.status?.toLowerCase() === "information required";
  const isCurrentBillIRUpdated = bill.status?.toLowerCase() === "ir updated";

  const hasBlockingBill = isMultipleBills && allBills.some(
    (b) => b.status?.toLowerCase() === "information required" || 
           b.status?.toLowerCase() === "ir updated"
  );

  // Handle status mismatch
  if (statusMismatch) {
    return "Under Process";
  }

  // Single Bill Logic
  if (isSingleBill) {
    if (["pre approved", "pre rejected", "partially pre approved", "recheck"].includes(claimRemarks)) {
      return "Under Process";
    }
    if (claimRemarks === "information required" || isCurrentBillInfoRequired) {
      return "Information Required";
    }
    if (claimRemarks === "resubmitted" || isCurrentBillIRUpdated) {
      return "Resubmitted";
    }
    if (claimRemarks === "submitted") {
      return "Submitted";
    }
    if (claimRemarks === "approved" || claimRemarks === "partially approved") {
      return capitalizeFirstLetter(claimRemarks);
    }
    if (claimRemarks === "rejected") {
      return "Rejected";
    }
    if (claimRemarks === "raised for payment") {
      return "Raised For Payment";
    }
    if (claimRemarks === "payment settled") {
      return "Payment Settled";
    }
    return capitalizeFirstLetter(bill.status);
  }

  // Multiple Bills with Blocking
  if (hasBlockingBill) {
    if (isCurrentBillInfoRequired) return "Information Required";
    if (isCurrentBillIRUpdated) return "Resubmitted";
    return "Under Process";
  }

  // Multiple Bills without Blocking
  if (["pre approved", "pre rejected", "partially pre approved", "recheck"].includes(claimRemarks)) {
    return "Under Process";
  }
  if (claimRemarks === "submitted") return "Submitted";
  if (claimRemarks === "resubmitted") return "Resubmitted";
  if (["approved", "partially approved", "rejected"].includes(claimRemarks)) {
    return capitalizeFirstLetter(bill.status);
  }
  if (claimRemarks === "raised for payment") return "Raised For Payment";
  if (claimRemarks === "payment settled") return "Payment Settled";

  return capitalizeFirstLetter(bill.status);
};

const shouldShowApprovedAmount = (bill, claimRemarks, allBills, statusMismatch) => {
  if (statusMismatch) return false;

  const isCurrentBillInfoRequired = bill.status?.toLowerCase() === "information required";
  const totalBills = allBills.length;
  const isSingleBill = totalBills === 1;
  const isMultipleBills = totalBills > 1;

  const hasBlockingBill = isMultipleBills && allBills.some(
    (b) => b.status?.toLowerCase() === "information required" || 
           b.status?.toLowerCase() === "ir updated"
  );

  // For information required bills, show if amount exists
  if (isCurrentBillInfoRequired && bill.approvedamount) {
    return true;
  }

  const l2AndPaymentStatuses = ["approved", "partially approved", "rejected", "raised for payment", "payment settled"];

  // Single Bill
  if (isSingleBill) {
    return l2AndPaymentStatuses.includes(claimRemarks);
  }

  // Multiple Bills with Blocking
  if (hasBlockingBill) {
    return isCurrentBillInfoRequired && bill.approvedamount;
  }

  // Multiple Bills without Blocking
  return l2AndPaymentStatuses.includes(claimRemarks);
};

const shouldShowRemarks = (bill, claimRemarks, allBills, statusMismatch) => {
  if (statusMismatch) return false;

  const isCurrentBillInfoRequired = bill.status?.toLowerCase() === "information required";
  const totalBills = allBills.length;
  const isSingleBill = totalBills === 1;
  const isMultipleBills = totalBills > 1;

  const hasBlockingBill = isMultipleBills && allBills.some(
    (b) => b.status?.toLowerCase() === "information required" || 
           b.status?.toLowerCase() === "ir updated"
  );

  if (isCurrentBillInfoRequired && bill.remarks) {
    return true;
  }

  const l2AndPaymentStatuses = ["approved", "partially approved", "rejected", "raised for payment", "payment settled"];

  if (isSingleBill) {
    return l2AndPaymentStatuses.includes(claimRemarks);
  }
  if (hasBlockingBill) {
    return isCurrentBillInfoRequired && bill.remarks;
  }

  return l2AndPaymentStatuses.includes(claimRemarks);
};
const getClaimStatusColor = (remarks) => {
  return CLAIM_STATUS_COLORS[remarks?.toLowerCase()] || DEFAULT_STATUS_COLOR;
};


 const viewFile = async (url) => {
    if (isWebView()) {
      let request = {
        fileUrl: url,
      };
      try {
        await taskDeviceBridge.showFileViewer(request);
      } catch (error) {
        console.error(error);
      }
    } else {
      window.open(url, "_blank");
    }
  };


  return (
    <main>
      <NavBar page={page} redirect={"/"} userName={props.userName} />

      <Container>
        {claimReportData ? (
          <Container>
            {!isMobile(window.innerWidth) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <button
                  onClick={() => navigate(-1)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    border: "1px solid #A4B0C0",
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                    cursor: "pointer",
                    minWidth: "48px",
                    height: "48px",
                    boxShadow: "0 1px 2px 0 rgba(23, 27, 34, 0.05)",
                  }}
                  aria-label={ACCESSIBILITY_LABELS.NAVIGATION.GO_BACK}
                >
                  <ArrowBackIcon sx={{ color: "#141B34", fontSize: "20px" }} />
                </button>
               
                <div>
                  <h1
                    tabIndex={"0"}
                    aria-label={ACCESSIBILITY_LABELS.CLAIMS.CLAIM_ID(spellOutId(claimReportData[0].claimdata[0]?.claimid))}
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: 600,
                      color: "#252D38",
                      margin: "0 0 4px 0",
                    }}
                  >
                    Claim ID: {claimReportData[0].claimdata[0]?.claimid}
                  </h1>
                  <p
                    tabIndex={"0"}
                    style={{
                      fontSize: "1rem",
                      fontWeight: 300,
                      color: "#47566A",
                      margin: 0,
                    }}
                  >
                    Created on{" "}
                    {formatDate(claimReportData[0].claimdata[0]?.createddate)}
                  </p>
                </div>
              </div>
            )}
             <>
              <br />
           <ClaimTimeline 
          displayStatus={capitalizeFirstLetter(claimDisplayStatus)} 
          claimId={claimReportData[0].claimdata[0]?.claimid}
          authToken={access_token}
             />
             <div className="line"/>
              <h2
                tabIndex={"0"}
                className="margin"
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 500,
                  color: "#252D38",
                  marginBottom: "20px",
                  marginTop:"15px",
                }}
              >
                Claim Details{" "}
              </h2>
              {claimReportData[0]?.claimdata?.length > 0 ? (
                <>
                  <div>
                    <div className="grid-container claim-details">
                      <p tabIndex={"0"} aria-hidden="true">Claim id:</p>
                      <p
                        tabIndex={"0"}
                        aria-label={ACCESSIBILITY_LABELS.CLAIMS.CLAIM_ID(spellOutId(claimReportData[0].claimdata[0].claimid))}
                      >
                        {claimReportData[0].claimdata[0].claimid}
                      </p>
                      <p tabIndex={"0"}>Patient Name:</p>
                      <p tabIndex={"0"}>
                        {claimReportData[0].claimdata[0].name}
                      </p>
                      <p tabIndex={"0"}>Employee id:</p>
                      <p tabIndex={"0"}>
                        {claimReportData[0].claimdata[0].employeeid}
                      </p>
                      <p tabIndex={"0"}>Relationship:</p>
                      <p tabIndex={"0"}>
                        {
                          relationShip[
                            claimReportData[0].claimdata[0].relationid
                          ]
                        }
                      </p>
                      <p tabIndex={"0"}>UTR Number:</p>
                      {claimReportData[0].claimdata[0].utr ? (
                        <p tabIndex={"0"}>
                          {claimReportData[0].claimdata[0].utr}
                        </p>
                      ) : (
                        <p tabIndex={"0"}>N/A</p>
                      )}
                      <p tabIndex={"0"}>Claim Amount:</p>
                      <p tabIndex={"0"}>
                        ₹{claimReportData[0].claimdata[0].claimamount}.00
                      </p>

                      <p tabIndex={"0"}>Claim Status:</p>
                      <p
                        tabIndex={"0"}
                        style={{
                          color: statusMismatch
                            ? "#004FB6"
                            : getClaimStatusColor(
                                claimReportData[0].claimdata[0].remarks
                              ),
                        }}
                      >
                       {capitalizeFirstLetter(claimDisplayStatus)}
                      </p>

                      <p tabIndex={"0"}>Approved Amount:</p>
                      {claimReportData[0].claimdata[0].remarks ===
                        "submitted" ||
                      claimReportData[0].claimdata[0].remarks ===
                        "pre approved" ||
                      claimReportData[0].claimdata[0].remarks ===
                        "pre rejected" ||
                      claimReportData[0].claimdata[0].remarks ===
                        "partially pre approved" ||
                      claimReportData[0].claimdata[0].remarks === "recheck" ||
                      claimReportData[0].claimdata[0].remarks ===
                        "resubmitted" ? (
                        <p tabIndex={"0"}>N/A</p>
                      ) : (
                        <p tabIndex={"0"}>
                          ₹{claimReportData[0].claimdata[0].approvedclaimamount}
                          .00
                        </p>
                      )}
                    </div>
                  </div>
                  <br />
                </>
              ) : (
                <> N/A </>
              )}
            </>
            <div className="line" />
            <br />

            <>
              <h2
                tabIndex={"0"}
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 500,
                  color: "#252D38",
                  marginBottom: "1.2rem",
                }}
              >
                Bill Details
              </h2>

              {claimReportData[2]?.billdatat?.length > 0 ? (
                <>
                  {claimReportData[2].billdatat.map((row, index) => {
                    const claimRemarks =
                      claimReportData[0].claimdata[0].remarks;
                    const allBills = claimReportData[2].billdatat;
                    const billStatus = getBillStatusDisplay(
                      row,
                      claimRemarks,
                      allBills,
                      statusMismatch
                    );
                    const showAmount = shouldShowApprovedAmount(
                      row,
                      claimRemarks,
                      allBills,
                      statusMismatch
                    );
                    const showRemark = shouldShowRemarks(
                      row,
                      claimRemarks,
                      allBills,
                      statusMismatch
                    );

                    const getStatusBadgeColors = (status) => {
                      if (status === "Submitted" || status === "Resubmitted") {
                        return { bg: "#FAFAFF", color: "#5E40AD" };
                      }
                      if (
                        status === "Under Process" ||
                        status === "Raised For Payment"
                      ) {
                        return { bg: "#F1F7FF", color: "#004FB6" };
                      }
                      if (status === "Information Required") {
                        return { bg: "#FFFAF6", color: "#AB5200" };
                      }
                      if (
                        status === "Approved" ||
                        status === "Partially Approved" ||
                        status === "Payment Settled"
                      ) {
                        return { bg: "#F8FBFA", color: "#0F7A48" };
                      }
                      if (status === "Rejected") {
                        return { bg: "#FFF4F5", color: "#AE0006" };
                      }
                      return { bg: "#F5F5F5", color: "#252D38" };
                    };

                    const badgeColors = getStatusBadgeColors(billStatus);

                    return (
                      <div key={index} className="bill-details">
                        <div
                          className="bill-status-badge"
                          style={{
                            backgroundColor: badgeColors.bg,
                            color: badgeColors.color,
                          }}
                        >
                          {billStatus}
                        </div>
                        <div className="grid-container claim-details">
                          <p tabIndex={"0"}>Bill No:</p>
                          <p tabIndex={"0"}>{row.billnumber}</p>

                          <p tabIndex={"0"}>Bill Date:</p>
                          <p tabIndex={"0"}>{row.billdate}</p>

                          <p tabIndex={"0"}>Bill Type:</p>
                          <p tabIndex={"0"}>{getFormName(row.category)}</p>

                          <p tabIndex={"0"}>Hospital Name:</p>
                          <p tabIndex={"0"}>{row.hospitalname}</p>

                          <p tabIndex={"0"}>Bill Amount:</p>
                          <p tabIndex={"0"}>₹{row.billamount}.00</p>
                          <p tabIndex={"0"}>Approved Amount:</p>
                          <p tabIndex={"0"}>
                            {showAmount
                              ? "₹" + row.approvedamount + ".00"
                              : "N/A"}
                          </p>

                          <p tabIndex={"0"}>Remarks:</p>
                          <p
                            tabIndex={"0"}
                            style={{
                              overflowWrap: "break-word",
                              wordBreak: "break-word",
                              wordWrap: "break-word",
                            }}
                          >
                            {showRemark
                              ? capitalizeFirstLetter(row.remarks)
                              : "N/A"}
                          </p>
                        </div>
                        <br />
                      </div>
                    );
                  })}
                </>
              ) : (
                <> N/A </>
              )}
            </>

            <>
              {/* { !claimBlacklist.includes(claimId) ? */}
              <>
                <h2
                  tabIndex={"0"}
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 500,
                    color: "#252D38",
                    margin: "20px 0px",
                  }}
                >
                  Claim Documents
                </h2>

                {claimReportData[3]?.claimDocsNew?.length > 0 ? (
                  <>
                    <div
                      className="docs-container"
                      style={{ marginBottom: "20px" }}
                    >
                      {bankFlag &&
                      claimReportData[1].bankdata.length > 0 &&
                      claimReportData[1].bankdata[0].accountproofurl !== "" &&
                      claimReportData[1].bankdata[0].accountproofurl ? (
                        <>
                          <p className="claim-details" aria-hidden="true">
                            Bank Cheque Leaf
                          </p>
                          <div
                            role={ACCESSIBILITY_LABELS.ROLES.BUTTON}
                            tabIndex={0}
                            aria-label={ACCESSIBILITY_LABELS.CLAIMS.VIEW_BANK_CHEQUE}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              cursor: "pointer",
                              justifyContent: "center",
                              marginBottom: "10px",
                            }}
                            onClick={() =>
                              viewFile(
                                claimReportData[1].bankdata[0].accountproofurl
                              )
                            }
                            onKeyDown={handleKeyboardClick(() =>
                              viewFile(
                                claimReportData[1].bankdata[0].accountproofurl
                              )
                            )}
                          >
                            <img
                              src={eyeIcon}
                              alt="eyeIcon"
                              aria-hidden="true"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                color: "#004FB6",
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              {isMobile(window.innerWidth)
                                ? "View"
                                : "View Document"}
                            </span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {claimReportData[3].claimDocsNew.map((row, index) => (
                        <>
                          <p className="claim-details" aria-hidden="true">
                            Claim Document {index + 1} ({" "}
                            {row.isInactive && row.isInactive == true
                              ? "Inactive"
                              : "Current"}{" "}
                            ){" "}
                          </p>
                          <div
                            role={ACCESSIBILITY_LABELS.ROLES.BUTTON}
                            tabIndex={0}
                            aria-label={ACCESSIBILITY_LABELS.CLAIMS.VIEW_CLAIM_DOCUMENT(index + 1, row.isInactive)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              cursor: "pointer",
                              justifyContent: "center",
                              marginBottom: "10px",
                            }}
                            onClick={() => viewFile(row.billurl)}
                            onKeyDown={handleKeyboardClick(() => viewFile(row.billurl))}
                          >
                            <img
                              src={eyeIcon}
                              alt="eyeIcon"
                              aria-hidden="true"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                color: "#004FB6",
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              {isMobile(window.innerWidth)
                                ? "View"
                                : "View Document"}
                            </span>
                          </div>
                        </>
                      ))}
                    </div>
                  </>
                ) : (
                  <> N/A </>
                )}
              </>
              <div className="line" />
              <br />
              <>
                {bankFlag && claimReportData[1].bankdata.length > 0 ? (
                  <>
                    <h2
                      tabIndex={"0"}
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: 500,
                        color: "#252D38",
                        marginBottom: "20px",
                      }}
                    >
                      Bank Details{" "}
                    </h2>

                    <div>
                      <div
                        className="grid-container claim-details"
                        style={{ marginBottom: "20px" }}
                      >
                        <p tabIndex={"0"}>Account Holder Name:</p>
                        <p tabIndex={"0"}>
                          {claimReportData?.[1]?.bankdata?.[0]?.accountholdername || claimReportData?.[1]?.bankdata?.[0]?.benef_name_bank_returned}
                        </p>
                        <p tabIndex={"0"}>Bank Name:</p>
                        <p tabIndex={"0"}>
                          {claimReportData[1].bankdata[0].bankname}
                        </p>
                        <p tabIndex={"0"}>Account Number:</p>
                        <p tabIndex={"0"}>
                          {claimReportData[1].bankdata[0].accountholdernumber}
                        </p>
                        <p tabIndex={"0"}>IFSC Code:</p>
                        <p tabIndex={"0"}>
                          {claimReportData[1].bankdata[0].ifsccode}
                        </p>
                      </div>
                    </div>
                    <br />
                  </>
                  
                ) : (
                  <> </>
                )}
                
              </>
            </>
          </Container>
        ) : (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            {loading ? (
              <CircularProgress color="inherit" />
            ) : (
              <p sx={{ color: "#212529" }}>
                {loginFlag ? (
                  <strong>
                    {message} Please signin{" "}
                    <a href="https://www.medibuddy.in">here</a>
                  </strong>
                ) : (
                  <strong> {message} </strong>
                )}
              </p>
            )}
          </Backdrop>
        )}
        {!loading && (
          <div
            className="mobile-page-with-footer"
            style={{ paddingBottom: "60px", paddingTop: "40px" }}
          >
            <MobileSecurityFooter />
          </div>
        )}
      </Container>

    </main>
  );
}
